module.exports = __webpack_public_path__ + "bb8622d34c8167176540158657f0bf92.png";